import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import Select from "react-select";
import {
  AJOUTER_PRESTATAIRE,
  LISTE_COMMUNE_SANS_PAGINATION,
  LISTE_PRESTATAIRE,
} from "../../Utils/constant";
import { find, store } from "../../services/service";
import { useStoreApp } from "../../store/storeApp";

export const AddPrestataire = () => {
  const communeData = [];
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [select, setSelect] = useState([]);
  const [selectedCoordinateur, setSelectedCoordinateur] = useState(null);
  const prestataire = useStoreApp();
  const [communes, setCommunes] = useState([]);
  const [loadingCommunes, setLoadingCommunes] = useState(false);
  const [coordinateurs, setCoordinateurs] = useState([]);
  const [loadingCoordinateurs, setLoadingCoordinateurs] = useState(false);

  const submit = (data) => {
    setIsSubmit(true);
    store(AJOUTER_PRESTATAIRE, "application/json", {
      ...data,
      listesCommunes: select.map((item) => item.value),
    })
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          prestataire.getData(
            LISTE_PRESTATAIRE,
            { page: 0, param: "", size: 10 },
            ""
          );
          document.getElementById("close_prestataire").click();
          reset();
          toast.success("Prestataire enregistré ");
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response.data.donnee);
      });
  };

  useEffect(() => {
    const load = async () => {
      setLoadingCommunes(true);
      try {
        const res = await find(`${LISTE_COMMUNE_SANS_PAGINATION}`);
        const items = res?.data?.data ?? res?.data?.donnee ?? res?.data ?? [];
        setCommunes(items);
      } catch (err) {
        console.error(err);
        toast.error(
          err?.response?.data?.donnee || "Erreur chargement communes"
        );
        setCommunes([]);
      } finally {
        setLoadingCommunes(false);
      }
    };
    load();
  }, []);

  communes?.map((item) => {
    return communeData.push({ value: item?.id, label: item?.designation });
  });

  return (
    <>
      <form onSubmit={handleSubmit(submit)} className="px-2">
        <div className="my-4 space-y-4">
          <div className="my-2">
            <label htmlFor="" className="text-sm font-medium">
              Nom du prestataire<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="designation"
              className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
              {...register("designation", { required: true })}
            />
            {errors.designation && (
              <span className="text-sm text-rose-600">
                Ce champs est obligatoire
              </span>
            )}
          </div>

          <div className="my-2">
            <label htmlFor="" className="text-sm font-medium">
              Commune <span className="text-red-500">*</span>
            </label>
            <Select
              isMulti
              onChange={(e) => setSelect(e)}
              options={communeData}
            />
          </div>

          <button
            type="submit"
            disabled={isSubmit ? true : false}
            className={`${
              !isSubmit ? "text-black bg-main" : "text-slate-800 bg-slate-200 "
            } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
          >
            {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
            {isSubmit ? (
              <span className="loading loading-dots loading-xs"></span>
            ) : null}
          </button>
        </div>
      </form>
    </>
  );
};
